import React from 'react'
import FormField from '../../../../Components/FormField'
import { SITTINGS } from '../utils/sittingTimeValidation'

export function UpsellEditor({ upsellForm, menuItems, onUpsellChange }) {
  const menuItemOptionsForSitting = (sittingKey) => {
    return menuItems
      .filter(mi => mi.sittings.includes(sittingKey))
      .map(mi => ({
        value: mi.id,
        label: `${mi.name} (${mi.price_formatted})`
      }))
  }

  return (
    <div className="bg-white shadow rounded-lg overflow-hidden">
      <div className="px-4 py-5 sm:px-6 border-b border-gray-200">
        <h3 className="text-lg font-medium text-gray-900">Checkout Upsells</h3>
        <p className="mt-1 text-sm text-gray-500">
          Suggest an add-on item to customers at checkout for each sitting
        </p>
      </div>
      <div className="px-4 py-5 sm:p-6">
        <div className="space-y-6">
          {SITTINGS.map(({ key, label }) => {
            const data = upsellForm[key] || {}
            const options = menuItemOptionsForSitting(key)

            return (
              <div key={key} className="border-b border-gray-100 pb-4 last:border-0 last:pb-0">
                <h4 className="text-sm font-medium text-gray-900 mb-3">{label}</h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <FormField
                    label="Menu Item"
                    name={`upsell-${key}-menu-item`}
                    type="select"
                    value={data.menu_item_id || ''}
                    onChange={(e) => onUpsellChange(key, 'menu_item_id', e.target.value)}
                    options={[{ value: '', label: 'No upsell' }, ...options]}
                  />
                  <FormField
                    label="CTA Title"
                    name={`upsell-${key}-cta-title`}
                    type="text"
                    value={data.cta_title || ''}
                    onChange={(e) => onUpsellChange(key, 'cta_title', e.target.value)}
                    placeholder="e.g. Add chips to your order"
                    disabled={!data.menu_item_id}
                  />
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
